/**
 * Shared styles for "content" pages (About / Terms / Privacy / GDPR) so they feel
 * consistent and readable: normal max width, good typography hierarchy, and
 * comfortable paragraph spacing.
 */
export function contentPageStyles(theme) {
  return {
    root: {
      padding: theme.spacing(4),
      margin: 0,
      // Content pages should not look like "pill" cards; keep corners subtle.
      // Some themes set a large global borderRadius, so cap it for these pages.
      borderRadius: Math.min(Number(theme.shape.borderRadius) || 0, 12),
      textAlign: "left",
    },
    headline: {
      fontSize: "1.6rem",
      fontWeight: 800,
      lineHeight: 1.2,
      marginBottom: theme.spacing(2),
      color: theme.palette.text.primary,
    },
    smallSubTitle: {
      fontSize: "1.1rem",
      fontWeight: 600,
      lineHeight: 1.35,
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1.5),
      color: theme.palette.text.secondary,
    },
    para: {
      margin: 0,
      marginBottom: theme.spacing(3),
      lineHeight: 1.7,
      fontSize: "1rem",
      color: theme.palette.text.secondary,
    },
    regularLink: {
      color: theme.palette.primary.main,
    },
  };
}

/**
 * MUI v7 styling: same styles as `contentPageStyles`, but in an `sx`-friendly shape.
 * Prefer this over `contentPageStyles` in new code.
 */
export function contentPageSx(theme) {
  return contentPageStyles(theme);
}
